export default function Image() {
  return (
    <main>
      <p>Bild nicht gefunden</p>
    </main>
  );
}
